export default __webpack_public_path__ + "static/media/close.572f51b2.svg";